
//import FormField from 'components/form/FormField';
import GridEx from 'components/form/GridEx';
import { getEntityDescriptor } from 'global/entityDescriptors';
import { FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import FormFieldHigh from '../../components/form/FormFieldHigh';

const styles = theme => ({
    label: {
        ...theme.typography.body1,
        marginRight: theme.spacing.unit,
        color: theme.palette.text.secondary,
        fontWeight: 'bold',
    },
    value: {
        ...theme.typography.body1,
        color: theme.palette.text.secondary,
        paddingLeft: theme.spacing.unit * 2,
    },
    formControl: {
        
        whiteSpace: 'normal',
    },
});

class ReadOnlyNewLine extends FormFieldHigh {

    render() {
        const { classes } = this.props;
        let value = '';
        if (this.props.f && this.context.dataSource) {
            value = this.context.dataSource[this.props.f];
        }
        if (this.props.v) {
            value = this.props.v;
        }

        const objDescriptor = getEntityDescriptor(this.context.objType);
        const propDescriptor = objDescriptor[this.props.f];
        const propType = propDescriptor ? propDescriptor.type : this.props.type;

        if (this.context.fields && this.context.fields.all.length > 0) {
            if (!this.context.fields.byId[this.props.f]) {
                return '';
            }
        }

        let text;
        if (propType === 'BOOLEAN') {
            text = value === 'true' ? 'si' : 'no';
        } else {
            text = this.convertToControl(value, propType, true);
        }

        const label = this.getLabel();
        if (this.props.pdf) {
            const latestGroup = window.requestDetailsPdfData[window.requestDetailsPdfData.length - 1];
            latestGroup.fields.push({ label, value: text || '' });
        }

        return (

            <GridEx item sm={this.props.sm || 12} xs={this.props.xs || 12}>
                <FormControl className={classes.formControl}>
                    <span className={classes.label} >
                        {label}
                    </span>
                    <span className={classes.value}>
                        {text}
                    </span>
                </FormControl>
            </GridEx>

        );
    }
}

ReadOnlyNewLine.contextTypes = {
    onChange: PropTypes.func,
    registerControl: PropTypes.func,
    objType: PropTypes.string,
    dataSource: PropTypes.object,
    unRegisterControl: PropTypes.func,
    fields: PropTypes.Object,
};

export default withStyles(styles, { withTheme: true })(ReadOnlyNewLine);